<template>
  <div class="index">
    <div class="swiperIn">
      <swiperIn></swiperIn>
    </div>
    <div class="content">
      <div v-if="!isDesktop">
        <moveIns :data="data"></moveIns>
      </div>
      <indexHot></indexHot>
      <igaog></igaog>
      <indexIpro></indexIpro>
      <div v-if="!isDesktop">
        <indexTeachersin></indexTeachersin>
      </div>
      <div v-else>
        <indexTeachers></indexTeachers>
      </div>
      <indexNews></indexNews>
      <indexContact></indexContact>
    </div>
  </div>
</template>

<script>
import swiperIn from "@/components/swiper_in.vue";
import indexHot from "@/components/index_Hot.vue";
import igaog from "@/components/igaog.vue";
import indexIpro from "@/components/index_ipro.vue";
import indexTeachers from "@/components/index_Teachers.vue";
import indexNews from "@/components/index_News.vue";
import indexContact from "@/components/index_contact.vue";
import moveIns from "@/components/move_in.vue";
import indexTeachersin from "@/components/index_Teachers_in.vue";

import method from "@/utils/Untitl.js";
export default {
  components: {
    swiperIn,
    indexHot,
    igaog,
    indexIpro,
    indexTeachers,
    indexNews,
    indexContact,
    moveIns,
    indexTeachersin,
  },
  data() {
    return {
      // 初始化 isDesktop 状态
      isDesktop: window.innerWidth > 428,
      data: {},
    };
  },
  mounted() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    
    this.submitForm();
  },

  methods: {
    // 处理窗口大小变化的方法
    handleResize() {
      this.isDesktop = window.innerWidth > 428;
    },
    async submitForm() {
      const res = await method.base_info();
      // console.log(res);
      if (res.code === 1) {
        this.data = res.data;
      }
    },
  },
};
</script>

<style>
</style>